module.exports = __webpack_public_path__ + "static/media/IMG_20180324_134722.3e8d1511.jpg";